import type * as React from 'react';
import { TouchableOpacity, View } from 'react-native';

import { Icon } from '@gitbook/spine-icons';

import { sizes } from '../constants';
import { ThemedStyleSheet, useCurrentTheme } from '../theme';

/**
 * Radio is shown as a rounded box that is ticked (checked) when activated.
 */
export function Radio(props: {
    size?: number;
    value: boolean;
    onValueChange: (value: boolean) => void;
    readOnly?: boolean;
    disabled?: boolean;
}): React.ReactElement {
    const {
        size = sizes.ICON_400,
        value,
        onValueChange,
        readOnly = false,
        disabled = false,
    } = props;
    const [, styles] = useCurrentTheme(themedStyles);

    const style = [
        styles.checkbox,
        value && styles.checkboxChecked,
        {
            width: size,
            height: size,
            borderRadius: size,
        },
    ];

    const content = value ? <Icon.Check size={size * 0.7} style={styles.icon} /> : null;

    if (readOnly) {
        return <View style={style}>{content}</View>;
    }

    return (
        <TouchableOpacity disabled={disabled} style={style} onPress={() => onValueChange(!value)}>
            {content}
        </TouchableOpacity>
    );
}

const themedStyles = ThemedStyleSheet.create({
    checkbox: (theme) => ({
        cursor: 'pointer',
        borderRadius: theme.radiuses.medium,
        borderColor: theme.colors.border.main,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 1,
    }),
    checkboxChecked: (theme) => ({
        backgroundColor: theme.colors.primary.main,
        borderColor: theme.colors.primary.main,
    }),
    icon: (theme) => ({
        color: theme.colors.info.textInside,
    }),
});
